import { render, staticRenderFns } from "./UpdateAmount.vue?vue&type=template&id=0e86af17"
import script from "./UpdateAmount.vue?vue&type=script&lang=js"
export * from "./UpdateAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports